exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".set-password__container{width:70%;max-width:815px;margin-left:auto;margin-right:auto}.set-password__heading{color:#706c69;font-weight:500;display:block;font-size:18px}.forgot-password-sent{position:relative;padding-left:60px;color:#333;font-size:18px;line-height:20px;font-weight:800;width:400px;margin:30px auto;text-align:left}.forgot-password-sent img{width:40px;height:40px;position:absolute;top:50%;transform:translateY(-50%);left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c30f4e10","scoped":false,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/auth/password-reminder.vue
// module id = 864
// module chunks = 0